export default "__VITE_ASSET__Cx49_SlJ__"